import {
  ContentItemMenu,
  DeleteLinkButton,
  DuplicateLinkButton,
  EditLinkButton,
  RestrictedByTooltip,
} from "components";
import { ToggleVisibilityButton } from "components/buttons/linkButtons/toggleVisibilityButton/ToggleVisibilityButton";
import { type FC, useCallback } from "react";
import { type EmbeddedVideoOverview } from "../types/models";

const ENTITY_TYPE = "asset";

export interface Props {
  item: EmbeddedVideoOverview;
  handleEdit: (id: number, isDraft: boolean) => void;
  handleDuplicate: (ids: number[]) => void;
  handleDelete: (ids: number[], flowsCount?: number, packsCount?: number) => void;
  handleToggleVisibility: (id: number[], hidden: boolean) => () => void;
  readonly?: boolean;
  isChecked?: boolean;
  circle?: boolean;
  outlinedEllipsis?: boolean;
  hasPermission?: boolean;
  hideDisabled?: boolean;
}

export const EmbeddedVideosThreeDotsItemMenu: FC<Props> = (props) => {
  const {
    circle,
    outlinedEllipsis,
    readonly,
    isChecked,
    item,
    handleEdit,
    handleDuplicate,
    handleDelete,
    handleToggleVisibility,
    hideDisabled,
    hasPermission = true,
  } = props;

  const { flowsCount = 0, packsCount = 0, assignmentsCount = 0 } = item.dependencies || {};
  const dependenciesMap = { flows: flowsCount, packs: packsCount, "users or groups": assignmentsCount };
  const visibility = !hideDisabled;

  const onEditClick = useCallback(() => handleEdit(item.id, item.isDraft), [handleEdit, item.id, item.isDraft]);
  const onDuplicateClick = useCallback(() => handleDuplicate([item.id]), [handleDuplicate, item.id]);
  const onDeleteClick = useCallback(
    () => handleDelete([item.id], flowsCount, packsCount),
    [handleDelete, item.id, flowsCount, packsCount],
  );

  return (
    <RestrictedByTooltip hasPermission={hasPermission}>
      <ContentItemMenu
        circle={circle}
        outlinedEllipsis={outlinedEllipsis}
        isChecked={isChecked}
        readonly={readonly}
        dependencies={dependenciesMap}
        entityType={ENTITY_TYPE}
        item={item}
      >
        {visibility && (
          <ToggleVisibilityButton
            onClick={handleToggleVisibility([item.id], !item.visibility)}
            hidden={!item.visibility}
          />
        )}
        {!item.isPurchased && <EditLinkButton onClick={onEditClick} isDisabled={item.isPurchased || readonly} />}
        {!item.isPurchased && <DuplicateLinkButton isDisabled={item.isPurchased} onClick={onDuplicateClick} />}
        {!item.isPurchased && <DeleteLinkButton onClick={onDeleteClick} isDisabled={readonly} />}
      </ContentItemMenu>
    </RestrictedByTooltip>
  );
};
